module.exports = __webpack_public_path__ + "static/media/svg_3_3_3_1_1_2-01.98f79976.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/03/03/assets/svg_3_3_3_1_1_2-01.svg
// module id = 504
// module chunks = 0